export default __webpack_public_path__ + "static/media/team-member-card.bce0a3a9.jpg";